/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  UploadLogsService,
  IGetUploadLogsMethods,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IDownloadTrackerEventMethods,
  DownloadTrackerEventService
} from "./components";

export type ProvisionalPageAgent = IHeaderMethods &
  ISettingsMethods &
  IGetUploadLogsMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IDownloadTrackerEventMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new UploadLogsService(),
    new LoadingService(),
    new StaticPageContentService(),
    new DownloadTrackerEventService()
  ];
};

export const getAgent = () => {
  return createAgent<ProvisionalPageAgent>({
    plugins: getPlugins(),
  });
};
